import { utilHelper } from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = '/api/applicative'

export const applicativeService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
    translate
};


function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data, showAlert: false })
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data});
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data});
}

function deleteItem(id, db) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${db}`, 'DELETE', { })
}

function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', {})
}

function translate(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}